import { render, staticRenderFns } from "./ReferenceDestroy.vue?vue&type=template&id=71a8da2c&scoped=true&"
import script from "./ReferenceDestroy.vue?vue&type=script&lang=ts&"
export * from "./ReferenceDestroy.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceDestroy.vue?vue&type=style&index=0&id=71a8da2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a8da2c",
  null
  
)

export default component.exports